import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "103",
  height: "96",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"102\" height=\"95\" x=\".5\" y=\".5\" fill=\"#fff\" rx=\"7.5\"></rect><rect width=\"102\" height=\"95\" x=\".5\" y=\".5\" stroke=\"#EAECF0\" rx=\"7.5\"></rect><rect width=\"39\" height=\"8\" x=\"12\" y=\"36.5\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"23\" height=\"8\" x=\"12\" y=\"51.5\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"32\" height=\"40\" x=\"59\" y=\"28\" fill=\"#D0D5DD\" rx=\"6\"></rect>", 5)
  ])))
}
export default { render: render }